import {InjectionToken} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export const ASSETS_URL = new InjectionToken<BehaviorSubject<string>>('ASSETS_URL');
export const BACKEND_URL = new InjectionToken<BehaviorSubject<string>>('BACKEND_URL');
export const PLATFORM_URL = new InjectionToken<BehaviorSubject<string>>('PLATFORM_URL');
export const ALIST_URL = new InjectionToken<BehaviorSubject<string>>('ALIST_URL');
export const ALIST_VIEW_URL = new InjectionToken<BehaviorSubject<string>>('ALIST_VIEW_URL');
